import { render, staticRenderFns } from "./versionUpdateNotify.vue?vue&type=template&id=5eed2d18"
import script from "./versionUpdateNotify.vue?vue&type=script&lang=js"
export * from "./versionUpdateNotify.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports